<template>
  <div ref="popup" class="notifications">
    <div class="position-relative has-cursor-pointer">
      <a data-dd-action-name="notifications:bell" @click.prevent="showNotification = !showNotification">
        <img :src="`${baseUrl}/icons54/bell-icon.svg`" alt="Flexigo" />
        <img v-if="showOvalIcon" :src="`${baseUrl}/icons54/solid-oval.svg`" alt="Flexigo" class="solid-oval" />
      </a>
    </div>

    <div v-if="showNotification" class="card-box">
      <div class="p-3 text-start title-style bold border-bottom">{{ $t('flexigo.notifications.notifications') }}</div>
      <no-notification v-if="isListEmpty" />
      <div v-else>
        <div
          v-for="item in allNotifications.slice(0, 2)"
          :key="item.id"
          class="border-bottom pointer list-item text-start"
        >
          <div
            class="hstack gap-3 align-items-start p-3"
            :class="{ unread: !item.isRead }"
            @click.prevent="openNotificationsPage(item.id)"
          >
            <div class="flex-fill">
              <div class="hstack justify-content-between">
                <div class="d-flex align-items-center ticket-message__label text-nowrap">
                  {{ formattedCreationDateTime(item.creationTime) }}
                </div>
                <div v-if="!item.isRead">
                  <img :src="`${baseUrl}/icons54/solid-oval.svg`" alt="Flexigo" />
                </div>
              </div>
              <div class="my-2 fw-bold">
                {{ item.title }}
              </div>
              <div class="fw-normal description">{{ item.message }}</div>
            </div>
          </div>
        </div>
        <div v-if="showViewButton" style="background-color: #f6f7f9" class="border-top py-1">
          <button class="btn btn-link small-info-text lighter" @click.prevent="openNotificationsPage(null)">
            {{ $t('flexigo.common.viewAll') }} >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formattedDateFull } from '@/helpers/dateTime';
import noNotification from '../../screens/Notifications/rider/noNotification.vue';

export default {
  name: 'notificationModal',
  components: { noNotification },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      showNotification: false,
    };
  },
  computed: {
    allNotifications() {
      return this.$store.getters.allNotifications || [];
    },
    showViewButton() {
      return this.allNotifications.length > 2;
    },
    showOvalIcon() {
      return this.allNotifications.some((el) => el.isRead === false);
    },
    isListEmpty() {
      return !this.allNotifications.length > 0;
    },
  },
  async created() {
    await this.$store.dispatch('getAllNotifications', false);
  },
  async mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      const { popup } = this.$refs;
      if (popup && !popup.contains(event.target)) {
        this.showNotification = false;
      }
    },
    async openNotificationsPage(id) {
      const route = { name: 'notifications' };
      if (id !== null) {
        route.query = { id };
      }
      this.$router.push(route);
      this.showNotification = false;
    },
    formattedCreationDateTime(time) {
      const date = new Date(time);
      return formattedDateFull(date);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/sass/flexigo/_variables.scss';
.card-box {
  max-width: 300px;
  width: 300px;
  border-radius: 10px;
  border: solid 1px $light-border-color;
  background-color: $white;
  color: $dark-navy-blue;
  margin-bottom: 12px;
  position: fixed;
  display: block;
  right: 10%;
  overflow: auto;
}
.solid-oval {
  position: absolute;
  right: 0%;
}
.description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
